<template>
  <div class="page-box">
    <base-screen>
      <a-form-model ref="query" layout="inline" :model="query" @submit.native.prevent @submit="handleQuery">
        <a-form-model-item prop="loginName" label="登录名">
          <a-input allow-clear v-model="query.loginName" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="userName" label="用户姓名">
          <a-input allow-clear v-model="query.userName" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="state" label="状态">
          <a-select style="width: 120px;" allow-clear v-model="query.state" placeholder="请选择">
            <a-select-option v-for="item in stateOptions" :value="item.value" :key="item.value">{{item.label}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="dateRange" label="申请时间">
          <a-range-picker v-model="query.dateRange" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button @click="handleReset">重置</a-button>
        </a-form-model-item>
      </a-form-model>
    </base-screen>

    <base-table
      bordered
      :columns="columns"
      :dataSource="data"
      :pagination="page"
      :rowKey="x => x.bsnWithdrawApplyId"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #state="ctx">
        <a-tag :color="getStateColor(ctx)">{{getStateText(ctx)}}</a-tag>
      </template>
      <template #amount="ctx">
        <span>{{(ctx || 0).toFixed(2)}}</span>
      </template>
      <template #operation="ctx">
        <a-button type="link" @click="viewDetail(ctx)">详情</a-button>
        <a-button type="link" v-if="ctx.state === 0 || ctx.state === 5" @click="handleEdit(ctx)">修改</a-button>
        <a-button type="link" v-if="ctx.state === 0" @click="handleApprove(ctx)">通过</a-button>
        <a-button type="link" v-if="ctx.state === 0" @click="handleReject(ctx)">拒绝</a-button>
        <a-button type="link" v-if="ctx.state === 5" @click="handleRetry(ctx)">重试支付</a-button>
      </template>
    </base-table>

    <a-modal
      v-model="detailVisible"
      :title="'提现详情 - ' + (detailData && detailData.loginName || '')"
      :footer="null"
      :keyboard="false"
      :mask-closable="false"
      width="800px"
    >
      <a-spin :spinning="detailLoading">
        <div v-if="detailData" class="detail-content">
          <a-descriptions :column="2" bordered>
            <a-descriptions-item label="用户姓名">{{detailData.userName || '-'}}</a-descriptions-item>
            <a-descriptions-item label="登录名/手机号">{{detailData.loginName || '-'}}</a-descriptions-item>
            <a-descriptions-item label="提现金额(元)">{{(detailData.withdrawAmount || 0).toFixed(2)}}</a-descriptions-item>
            <a-descriptions-item label="手续费(元)">{{(detailData.serviceFee || 0).toFixed(2)}}</a-descriptions-item>
            <a-descriptions-item label="实际到账金额(元)">{{(detailData.actualAmount || 0).toFixed(2)}}</a-descriptions-item>
            <a-descriptions-item label="状态"><a-tag :color="getStateColor(detailData.state)">{{getStateText(detailData.state)}}</a-tag></a-descriptions-item>
            <a-descriptions-item label="开户银行">{{detailData.bankName || '-'}}</a-descriptions-item>
            <a-descriptions-item label="持卡人姓名">{{detailData.bankCardName || '-'}}</a-descriptions-item>
            <a-descriptions-item label="银行卡号">{{detailData.bankCardNo || '-'}}</a-descriptions-item>
            <a-descriptions-item label="申请时间">{{detailData.applyTime || '-'}}</a-descriptions-item>
            <a-descriptions-item label="审核人">{{detailData.checkUser || '-'}}</a-descriptions-item>
            <a-descriptions-item label="审核时间">{{detailData.checkTime || '-'}}</a-descriptions-item>
            <a-descriptions-item label="拒绝理由">{{detailData.refuseCause || '-'}}</a-descriptions-item>
            <a-descriptions-item label="商户订单号">{{detailData.merchantOrderNo || '-'}}</a-descriptions-item>
            <a-descriptions-item label="平台流水号">{{detailData.platformSerialNo || '-'}}</a-descriptions-item>
            <a-descriptions-item label="备注">{{detailData.remark || '-'}}</a-descriptions-item>
          </a-descriptions>
          <div style="margin-top: 20px; text-align: right;">
            <a-button v-if="detailData.state === 0 || detailData.state === 5" type="primary" @click="handleEdit(detailData)">修改银行卡信息</a-button>
            <a-button v-if="detailData.state === 0" type="primary" @click="handleApprove(detailData)">审核通过</a-button>
            <a-button v-if="detailData.state === 0" @click="handleReject(detailData)">拒绝</a-button>
            <a-button v-if="detailData.state === 5" type="primary" @click="handleRetry(detailData)">重试支付</a-button>
            <a-button @click="detailVisible = false">关闭</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>

    <a-modal
      v-model="rejectVisible"
      title="拒绝提现申请"
      :footer="null"
      :keyboard="false"
      :mask-closable="false"
      width="500px"
    >
      <a-form-model
        layout="horizontal"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
        :model="rejectForm"
        ref="rejectFormRef"
        :colon="false"
      >
        <a-form-model-item label="拒绝理由" prop="refuseCause" :rules="[
          { required: true, message: '请输入拒绝理由' }
        ]">
          <a-textarea v-model="rejectForm.refuseCause" :rows="4" placeholder="请输入拒绝理由"></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="审核人" prop="checkUser" :rules="[
          { required: true, message: '请输入审核人ID' }
        ]">
          <a-input v-model="rejectForm.checkUser" placeholder="请输入审核人ID"></a-input>
        </a-form-model-item>
      </a-form-model>
      <div style="margin-top: 20px; text-align: right;">
        <a-button @click="rejectVisible = false">取消</a-button>
        <a-button type="primary" :loading="rejectLoading" @click="submitReject">确认拒绝</a-button>
      </div>
    </a-modal>

    <a-modal
      v-model="editVisible"
      title="修改银行卡信息"
      :footer="null"
      :keyboard="false"
      :mask-closable="false"
      width="500px"
    >
      <a-form-model
        layout="horizontal"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
        :model="editForm"
        ref="editFormRef"
        :colon="false"
      >
        <a-form-model-item label="用户名" prop="userName" :rules="[
          { required: true, message: '请输入用户名' }
        ]">
          <a-input v-model="editForm.userName" placeholder="请输入用户名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="银行卡号" prop="bankCardNo" :rules="[
          { required: true, message: '请输入银行卡号' }
        ]">
          <a-input v-model="editForm.bankCardNo" placeholder="请输入银行卡号"></a-input>
        </a-form-model-item>
        <a-form-model-item label="持卡人姓名" prop="bankCardName" :rules="[
          { required: true, message: '请输入持卡人姓名' }
        ]">
          <a-input v-model="editForm.bankCardName" placeholder="请输入持卡人姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="银行编码" prop="bankCode">
          <a-input v-model="editForm.bankCode" placeholder="请输入银行编码（选填）"></a-input>
        </a-form-model-item>
        <a-form-model-item label="银行名称" prop="bankName">
          <a-input v-model="editForm.bankName" placeholder="请输入银行名称（选填）"></a-input>
        </a-form-model-item>
      </a-form-model>
      <div style="margin-top: 20px; text-align: right;">
        <a-button @click="editVisible = false">取消</a-button>
        <a-button type="primary" :loading="editLoading" @click="submitEdit">确认修改</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch } from '@vue/composition-api'
import { getSession } from '@/utils/session'
import { SHOPID, SHOPUSERID } from '@/constants'
import { capital } from '@/api'
import { message } from 'ant-design-vue'

export default {
  name: 'PageBsnWithdraw',
  setup () {
    const getInitQuery = () => ({
      loginName: '',
      userName: '',
      state: void 0,
      dateRange: [],
      shopId: getSession(SHOPID),
    })
    const query = reactive(getInitQuery())

    const page = reactive({
      current: 1,
      size: 10,
      total: 0
    })

    const data = ref([])
    const loading = ref(false)
    async function getTableData () {
      loading.value = true
      const res = await capital.getBsnWithdrawPage({
        ...query,
        current: page.current,
        size: page.size,
        ...(query.dateRange.length ? {
          beginDate: query.dateRange[0].format('YYYY-MM-DD'),
          endDate: query.dateRange[1].format('YYYY-MM-DD'),
          dateRange: void 0
        } : null)
      })
      loading.value = false
      if (res.code === '00000') {
        page.total = res.page.total
        data.value = res.data
      }
    }
    onMounted(() => {
      getTableData()
    })

    function handleQuery () {
      page.current = 1
      getTableData()
    }

    function handleReset () {
      Object.assign(query, getInitQuery())
      handleQuery()
    }

    function handleTableChange ({ current }) {
      page.current = current
      getTableData()
    }

    const stateOptions = [
      { value: 0, label: '待审核' },
      { value: 1, label: '审核通过' },
      { value: 2, label: '审核不通过' },
      { value: 3, label: '代付处理中' },
      { value: 4, label: '代付成功' },
      { value: 5, label: '代付失败' },
    ]

    function getStateText (state) {
      const item = stateOptions.find(x => x.value === state)
      return item ? item.label : '未知'
    }

    function getStateColor (state) {
      const colors = {
        0: 'orange',
        1: 'blue',
        2: 'red',
        3: 'cyan',
        4: 'green',
        5: 'red',
      }
      return colors[state] || 'default'
    }

    const columns = [
      {
        title: '登录名',
        dataIndex: 'loginName'
      },
      {
        title: '用户姓名',
        dataIndex: 'userName'
      },
      {
        title: '提现金额(元)',
        dataIndex: 'withdrawAmount',
        scopedSlots: {
          customRender: 'amount'
        }
      },
      {
        title: '手续费(元)',
        dataIndex: 'serviceFee',
        scopedSlots: {
          customRender: 'amount'
        }
      },
      {
        title: '实际到账(元)',
        dataIndex: 'actualAmount',
        scopedSlots: {
          customRender: 'amount'
        }
      },
      {
        title: '状态',
        dataIndex: 'state',
        scopedSlots: {
          customRender: 'state'
        }
      },
      {
        title: '申请时间',
        dataIndex: 'applyTime'
      },
      {
        title: '操作',
        scopedSlots: {
          customRender: 'operation'
        }
      }
    ]

    const detailVisible = ref(false)
    const detailData = ref(null)
    const detailLoading = ref(false)
    async function viewDetail (row) {
      detailLoading.value = true
      const res = await capital.getBsnWithdrawDetail(row.bsnWithdrawApplyId)
      detailLoading.value = false
      if (res.code === '00000') {
        detailData.value = res.data
        detailVisible.value = true
      }
    }

    const rejectVisible = ref(false)
    const rejectForm = reactive({
      refuseCause: '',
      checkUser: getSession(SHOPUSERID) || ''
    })
    const rejectLoading = ref(false)
    let rejectId = null
    function handleReject (row) {
      rejectId = row.bsnWithdrawApplyId
      rejectForm.refuseCause = ''
      rejectVisible.value = true
    }

    const editVisible = ref(false)
    const editForm = reactive({
      userName: '',
      bankCardNo: '',
      bankCardName: '',
      bankCode: '',
      bankName: ''
    })
    const editLoading = ref(false)
    let editId = null
    function handleEdit (row) {
      editId = row.bsnWithdrawApplyId
      editForm.userName = row.userName || ''
      editForm.bankCardNo = row.bankCardNo || ''
      editForm.bankCardName = row.bankCardName || ''
      editForm.bankCode = row.bankCode || ''
      editForm.bankName = row.bankName || ''
      editVisible.value = true
    }

    async function submitEdit () {
      if (!editForm.bankCardNo.trim()) {
        message.error('请输入银行卡号')
        return
      }
      if (!editForm.bankCardName.trim()) {
        message.error('请输入持卡人姓名')
        return
      }
      editLoading.value = true
      try {
        await capital.updateBsnWithdraw(editId, {
          userName: editForm.userName,
          bankCardNo: editForm.bankCardNo,
          bankCardName: editForm.bankCardName,
          bankCode: editForm.bankCode || undefined,
          bankName: editForm.bankName || undefined
        })
        message.success('修改成功')
        editVisible.value = false
        getTableData()
      } catch (err) {
        message.error(err.message)
      } finally {
        editLoading.value = false
      }
    }

    async function submitReject () {
      if (!rejectForm.refuseCause.trim()) {
        message.error('请输入拒绝理由')
        return
      }
      if (!rejectForm.checkUser.trim()) {
        message.error('请输入审核人ID')
        return
      }
      rejectLoading.value = true
      try {
        await capital.rejectBsnWithdraw(rejectId, {
          checkUser: rejectForm.checkUser,
          refuseCause: rejectForm.refuseCause
        })
        message.success('拒绝成功')
        rejectVisible.value = false
        getTableData()
      } catch (err) {
        message.error(err.message)
      } finally {
        rejectLoading.value = false
      }
    }

    async function handleApprove (row) {
      const checkUser = getSession(SHOPUSERID)
      if (!checkUser) {
        message.error('请先登录')
        return
      }
      const confirm = await window.confirm('确认审核通过此提现申请？')
      if (!confirm) return
      try {
        await capital.approveBsnWithdraw(row.bsnWithdrawApplyId, checkUser)
        message.success('审核通过')
        if (detailVisible.value) {
          detailVisible.value = false
        }
        getTableData()
      } catch (err) {
        message.error(err.message)
      }
    }

    async function handleRetry (row) {
      const confirm = await window.confirm('确认重试支付此提现申请？')
      if (!confirm) return
      try {
        await capital.retryBsnWithdraw(row.bsnWithdrawApplyId)
        message.success('重试支付成功')
        if (detailVisible.value) {
          detailVisible.value = false
        }
        getTableData()
      } catch (err) {
        message.error(err.message)
      }
    }

    return {
      query,
      data,
      page,
      loading,
      handleQuery,
      handleReset,
      columns,
      handleTableChange,
      stateOptions,
      getStateText,
      getStateColor,
      detailVisible,
      detailData,
      detailLoading,
      viewDetail,
      rejectVisible,
      rejectForm,
      rejectLoading,
      handleReject,
      submitReject,
      editVisible,
      editForm,
      editLoading,
      handleEdit,
      submitEdit,
      handleApprove,
      handleRetry,
    }
  }
}
</script>

<style scoped>
.detail-content {
  padding: 10px;
}
</style>
